import { createBrowserRouter } from "react-router-dom";
import Layout from "/@/layout";
import Login from "/@/pages/login";
import Home from "./pages/home/home";
import OrderView from "/@/pages/orders/orderView";
import OrderEdit from "/@/pages/orders/edit/orderEdit";

import GroupList from "/@/pages/groups/groupList";
import ChatList from "/@/pages/notifications/chatList";
import HelpList from "/@/pages/notifications/helpList";
import GroupView from "/@/pages/groups/groupView";
import GroupNew from "/@/pages/groups/groupNew";
import UserList from "/@/pages/users/userList";
import UserView from "/@/pages/users/userView";
import UserEdit from "/@/pages/users/userEdit";
import { SteppedOrderEdit } from "/@/pages/orders/edit/SteppedOrderEdit";

import { NewItemComponent } from "@jasper/shared";
import ShippingPage from "./pages/ops/shipping";
import PickupList from "./pages/pickup/list";
import AnalyticsPage from "./pages/analytics";
import MaterialTraceabilityList from "./pages/material-traceability/list";
import BackToChinaList from "./pages/back-to-china/list";
import ExternalCaseList from "./pages/external-cases/external-cases-list";
import { SettingsPage } from "./pages/settings/SettingsPage";
import { ThreeShapeCallbackPage } from "./pages/oauth-integrations/ThreeShapeCallback";
import { DsCoreCallbackPage } from "./pages/oauth-integrations/DsCoreCallback";
import { OrderDesignsPage } from "./pages/orderDesigns/OrderDesignsPage";
import DesignNotificationPage from "./pages/notifications/Design";
import DesignReviewNotificationsPage from "./pages/notifications/DesignReview";
import LabsProductConfigure from "/@/pages/v2/orders/configure/LabsProductConfigure";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <Login />,
  },
  {
    element: <Layout />,
    children: [
      {
        path: "/home",
        element: <Home />,
      },
      {
        path: "/orders/:order_id",
        element: <OrderView />,
      },
      {
        path: "/orders/:order_id/edit",
        element: <OrderEdit />,
      },
      {
        path: "/orders/:order_id/stepped-edit/:product_id",
        element: <SteppedOrderEdit />,
      },
      {
        path: "/orders/:orderId/configure/products/:productId/:step?",
        element: <LabsProductConfigure />,
      },
      {
        path: "/orders/:order_id/edit/:product_id/new",
        element: <NewItemComponent />,
      },
      {
        path: "/orders/:order_id/edit/:product_id/edit",
        element: <NewItemComponent />,
      },
      {
        path: "/orders/:orderId/designs",
        element: <OrderDesignsPage />,
      },
      {
        path: "/chats",
        element: <ChatList />,
      },
      {
        path: "/help-demands",
        element: <HelpList />,
      },
      {
        path: "/groups",
        element: <GroupList />,
      },
      {
        path: "/groups/:group_id",
        element: <GroupView />,
      },
      {
        path: "/groups/:group_id/edit",
        element: <GroupNew />,
      },
      {
        path: "/groups/:group_id/material-traceability",
        element: <MaterialTraceabilityList />,
      },
      {
        path: "/groups/new",
        element: <GroupNew />,
      },
      {
        path: "/users",
        element: <UserList />,
      },
      {
        path: "/users/new",
        element: <UserEdit />,
      },
      {
        path: "/users/:user_id",
        element: <UserView />,
      },
      {
        path: "/users/:user_id/edit",
        element: <UserEdit />,
      },
      {
        path: "/ops/shipping",
        element: <ShippingPage />,
      },
      {
        path: "/pickups",
        element: <PickupList />,
      },
      {
        path: "/back-to-china",
        element: <BackToChinaList />,
      },
      {
        path: "/data",
        element: <AnalyticsPage />,
      },
      {
        path: "/external-cases",
        element: <ExternalCaseList />,
      },
      {
        path: "/settings",
        element: <SettingsPage />,
      },
      {
        path: "/orders/callback/3shape",
        element: <ThreeShapeCallbackPage />,
      },
      {
        path: "/orders/callback/dscore",
        element: <DsCoreCallbackPage />,
      },
      {
        path: "/order-designs",
        element: <DesignNotificationPage onlyUntranslatedComment={false} />,
      },
      {
        path: "/notifications/",
        children: [
          {
            path: "order-design",
            element: <DesignNotificationPage onlyUntranslatedComment={true} />,
          },
          {
            path: "design-to-review",
            element: <DesignReviewNotificationsPage />,
          },
        ],
      },
    ],
  },
]);
